import gql from "graphql-tag";

export const SendAppInvite = gql`
  mutation SendAppInvite($input: SendAppInviteInput!) {
    SendAppInvite(input: $input) {
      clientMutationId
    }
  }
`;


// WEBPACK FOOTER //
// ./src/queries/clients/mutations.js